import * as React from 'react';
import { camelCase } from 'lodash';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { DELIVERABLE_ICONS } from 'utils/deliverables';

import './cost-attribution-task-amount.scss';

type Props = {
  type: string,
  amount: number
};

const CostAttributionTaskAmount = (
  {
    type,
    amount
  }: Props
): JSX.Element => (
  <div className="cost-attribution-task-amount">
    <SVGDynamicIcon
      name={`${DELIVERABLE_ICONS[camelCase(type)]}`}
      width={16}
      height={16}
    />
    <span className="cost-attribution-task-amount__number">
      {amount}
    </span>
  </div>
);

export default CostAttributionTaskAmount;
